module.exports = __webpack_public_path__ + "static/img/icon-kpuser.4f07be10.svg";